import {
  Input,
  Inject,
  OnInit,
  Output,
  Component,
  EventEmitter,
} from 'ng-metadata/core';

import passportWizardHtml from './passport-wizard.html';
import './passport-wizard.scss';

@Component({
  selector: 'gw-passport-wizard',
  template: passportWizardHtml,
})
export class CheckoutPassportWizardComponent implements OnInit {

  public model: any = {};

  public state = {
    step: null,
    concluded: null,
    wizardSteps: {
      is_adult: {
        question: 'Is the applicant older than 16?',
        conclusion: `If the applicant is younger than 16 years old they must apply for a
          <strong>Child Passport</strong>. We will now change the passport type.`,
        yes: 'issued',
        no: 'conclude',
        switchTo: 'child-passport',
      },
      issued: {
        question: 'Has the applicant ever been issued a U.S. passport before?',
        conclusion: `The applicant must have previously been issued a U.S. passport
          to apply for a <strong>Passport Renewal</strong>. You must apply for a
          <strong>New Passport</strong>.  We will now change the passport type.`,
        yes: 'possession',
        no: 'conclude',
        switchTo: 'new-passport',
      },
      possession: {
        question: 'Does the applicant have possession of their previous passport?',
        // conclusion: `The applicant must be in possession of their previous passport
        //   to apply for a <strong>Passport Renewal</strong>. You must apply for a
        //   <strong>Lost Passport</strong> replacement. We will now change the passport type.`,
        yes: 'damaged',
        no: 'lost',
        // switchTo: 'lost-passport',
      },
      damaged: {
        question: 'Is the previous passport in possession damaged or mutilated in any way?',
        conclusion: `The applicant must be in possession of their undamaged previous passport
          to apply for a <strong>Passport Renewal</strong>. You must apply for a
          <strong>Damaged Passport</strong> replacement. We will now change the passport type.`,
        yes: 'conclude',
        no: 'was_adult',
        switchTo: 'damaged-passport',
        evaluation: `possession === 'yes'`,
      },
      lost: {
        question: 'Is it because the previous passport was lost or stolen?',
        yes: {
          switchTo: 'lost-passport',
          conclusion: `The applicant must be in possession of their undamaged previous passport
            to apply for a <strong>Passport Renewal</strong>. You must apply for a
            <strong>Lost Passport</strong> replacement. We will now change the passport type.`,
        },
        no: {
          switchTo: 'new-passport',
          conclusion: `The applicant must be in possession of their undamaged previous passport
            to apply for a <strong>Passport Renewal</strong>. You must apply for a
            <strong>New Passport</strong>. We will now change the passport type.`,
        },
      },
      was_adult: {
        question: 'Was the applicant older than 16 when their previous passport was issued?',
        conclusion: `If the applicant was younger than 16 years old when their previous
          passport was issued, they must apply for a <strong>New Passport</strong>.
          We will now change the passport type.`,
        yes: 'expired',
        no: 'conclude',
        switchTo: 'new-passport',
      },
      expired: {
        question: 'Has the applicant’s previous passport been expired for more than 5 years?',
        conclusion: `If the applicant’s passport expired more than 5 years ago they must apply
          for a <strong>New Passport</strong>. We will now change the passport type.`,
        yes: 'conclude',
        no: 'success',
        switchTo: 'new-passport',
      },
    },
  };

  @Input() option;
  @Output() onClose = new EventEmitter();

  constructor(
    @Inject('$parse') private $parse: ng.IParseService,
    @Inject('$scope') private $scope: ng.IScope,
  ) {}

  /**
   * Component init hook
   */
  ngOnInit() {
  }

  handleAction(id: string, answer: string) {
    const action = this.state.wizardSteps[id][answer];

    if (action === 'success') {
      return this.finishWizard(true);
    }

    if (action === 'conclude') {
      this.state.concluded = this.state.wizardSteps[id];
      return;
    }

    if (typeof action === 'object') {
      this.state.concluded = action;
      return;
    }

    // Save answer
    this.model[id] = answer;

    // Update to current step
    this.state.step = action;
  }

  evaluate(id: string) {
    const step = this.state.wizardSteps[id];

    if (typeof step.evaluation !== 'undefined') {
      return this.state.step === id && this.$scope.$eval(step.evaluation, this.model);
    }

    return this.state.step === id;
  }

  finishWizard(success = false) {
    if (success) {
      return this.onClose.emit({
        success: true,
      });
    }

    const newProduct = this.state.concluded.switchTo;

    this.onClose.emit({
      switchTo: newProduct,
    });
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/checkout/passport-wizard/passport-wizard.component.ts